import { render, staticRenderFns } from "./PlaceTitle.vue?vue&type=template&id=440f1a1e&"
import script from "./PlaceTitle.vue?vue&type=script&lang=js&"
export * from "./PlaceTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports